import { Pipe, PipeTransform } from '@angular/core';
import { DateTime } from 'luxon';

@Pipe({
  name: 'lmsDate'
})
export class DatePipe implements PipeTransform {
  transform(value: any, timezone?: any, format?: any): any {
    if (!value) {
      return '';
    }
    const lang = localStorage.getItem('backofficelanguage') || 'en';

    const dateTimeString = DateTime.fromISO(value, {
      zone: timezone
    })
      .setLocale(lang)
      .toLocaleString(format || DateTime.DATE_MED);

    return dateTimeString;
  }
}
